import { hexEq, type OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useMemo } from "react";
import type { Address } from "viem";
import { AddressSelector } from "./AddressSelector";

export interface CreditSuiteSelectorProps {
  sdk: OnchainSDK;
  market: Address | undefined;
  value: Address | undefined;
  onChange: (creditManager: Address | undefined) => void;
}

export const CreditSuiteSelector: FC<CreditSuiteSelectorProps> = props => {
  const { sdk, market, value, onChange } = props;

  const suites = useMemo(() => {
    if (!market) {
      return [];
    }
    const selected = sdk.marketRegister.markets.find(m =>
      hexEq(m.pool.pool.address, market),
    );
    return (
      selected?.creditManagers.map(suite => ({
        address: suite.creditManager.address,
        name: suite.name,
      })) ?? []
    );
  }, [sdk, market]);

  if (!market) {
    return null;
  }

  return (
    <>
      <h4>Credit suites</h4>
      <AddressSelector items={suites} value={value} onChange={onChange} />
    </>
  );
};
